module.exports = __webpack_public_path__ + "img/register_ercode.b78cacf5.png";